/**
 * @providesModule Spectacles
 * @flow
 */

import React from 'react'
import { connect } from 'react-redux'
import { Switch, Route, NavLink, Redirect } from 'react-router-dom'

import DocumentTitle from 'react-document-title'
import { Button } from '@blueprintjs/core'

import LogInDialog from './LogInDialog'
import ProtectionPicker from './ProtectionPicker'
import VisibleSchedulesList from './SchedulesList'
import VisibleFiltersList from './FiltersList'

import { getFilters, getSchedules, deleteToken } from '../../redux/actions'

import type { State } from '../../redux/state'

function mapStateToProps({ token }: State) {
  return { token }
}

const mapDispatchToProps = { getFilters, getSchedules, deleteToken }

type Props = { token: string } & typeof mapDispatchToProps
class Spectacles extends React.Component<Props> {
  state = { matchingFilterIds: null, searchVersion: 0 }

  clearSearch = () => {
    this.setState(({ searchVersion }) => ({ matchingFilterIds: null, searchVersion: searchVersion + 1 }))
  }

  constructor(props: Props) {
    super(props)

    if (props.token) {
      props.getFilters()
      props.getSchedules()
    }
  }

  render() {
    return (
      <DocumentTitle title="Spectacles">
        <main style={{ margin: '0 auto', maxWidth: '1200px' }}>
          <nav className="pt-navbar pt-dark">
            <div className="pt-navbar-group pt-align-left">
              <div className="pt-navbar-heading">Spectacles</div>
              <span className="pt-navbar-divider" />

              <NavLink
                to="/schedules"
                className="pt-button pt-minimal pt-icon-document"
                activeClassName="pt-active"
              >
                Schedules
              </NavLink>
              <NavLink
                to="/filters"
                className="pt-button pt-minimal pt-icon-flash"
                activeClassName="pt-active"
              >
                Filters
              </NavLink>
            </div>
            <div className="pt-navbar-group pt-align-right">
              <Route render={({ history }) => (
                <ProtectionPicker
                  key={this.state.searchVersion}
                  token={this.props.token}
                  active={this.state.matchingFilterIds !== null}
                  onClear={this.clearSearch}
                  onMatch={matchingFilterIds => {
                    this.setState({ matchingFilterIds })
                    history.push('/filters')
                  }}
                />
              )} />
              <span className="pt-navbar-divider" />
              <Button
                className="pt-minimal"
                text="Log out"
                iconName="log-out"
                onClick={this.props.deleteToken}
              />
            </div>
          </nav>

          <LogInDialog />

          {this.props.token && (
            <Switch>
              <Route path="/filters" render={routeProps => (
                <VisibleFiltersList {...routeProps}
                  matchingFilterIds={this.state.matchingFilterIds}
                />
              )} />
              <Route path="/schedules" component={VisibleSchedulesList} />
              <Redirect to="/filters" />
            </Switch>
          )}
        </main>
      </DocumentTitle>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Spectacles)
